// extracted by mini-css-extract-plugin
export default {"objectsContainer":"jGs9vyCvYBIuNbay_EIJ"};